import { render } from "./App.vue?vue&type=template&id=8b0752d0&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=8b0752d0&scoped=true&lang=css"

import exportComponent from "/Users/tian/Desktop/桌面 - 谭天’s MacBook Pro/tt/work/DEV/tooda-apps/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b0752d0"]])

export default __exports__